//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      illustrations: {
        ra: require("~/assets/icons/general/icon-service-ra.svg"),
        aoa: require("~/assets/icons/general/icon-service-aoa.svg"),
        fer: require("~/assets/icons/general/icon-service-fer.svg"),
        cogs: require("~/assets/icons/general/icon-service-cogs.svg"),
        bf: require("~/assets/icons/general/icon-service-bf.svg"),
      },
    };
  },
  props: {
    docs: {
      required: true,
    },
    blueBg: {
      required: false,
      default: false,
    },
  },
  methods: {
    icon(icon) {
      return this.illustrations[icon];
    },
  },
};
